// extracted by mini-css-extract-plugin
export default {"container":"BottomLead_container__GFVbM","text":"BottomLead_text__13eJi","form":"BottomLead_form__4JKtP"};